export const MODEL_ENDPOINT =
  "/:makeMaskingName([a-zA-Z0-9_-]+)-cars/:modelMaskingName([a-zA-Z0-9_-]+)/";
